export const ADD_CUSTOMER_DISPLAY = "ADD_CUSTOMER_DISPLAY"
export const EDIT_CUSTOMER_DISPLAY = "EDIT_CUSTOMER_DISPLAY"
export const DELETE_CUSTOMER_DISPLAY = "DELETE_CUSTOMER_DISPLAY"